(function ($) {

    function randomFunc(val1, val2) {
        let randNum = Math.floor((Math.random() * 2) + 1);

        if(randNum === 1){
            return val1;
        } else {
            return val2;
        }
    }

    $(".lang-link").on("click", function (e) {
        let link1 = $( e.target ).closest("div").attr("data-lang1");
        let link2 = $( e.target ).closest("div").attr("data-lang2");
        e.preventDefault();
        window.open(randomFunc(link1, link2), '_blank');
    });

    $(".en-lang-link").on("click", function (e) {
        let link1 = $( e.target ).closest("div").attr("data-en-lang1");
        let link2 = $( e.target ).closest("div").attr("data-en-lang2");
        e.preventDefault();
        window.open(randomFunc(link1, link2), '_blank');
    });

})(jQuery);


// WEBPACK FOOTER //
// ./src/js/custom/language-link-random.es6